module.exports = __webpack_public_path__ + "assets/img/mecha-btn-6bc2d119.png";